import { SECTOR_PERFORMANCE, SECTOR_PERFORMANCE_ERROR, SECTOR_PERFORMANCE_HIDE_ERROR, SECTOR_PERFORMANCE_STREAM, SECTOR_START_LOADER, SECTOR_STOP_LOADER, } from "../interface/iSectorPerformance";
import { marketStreamingUpdate } from "@domains/features/Markets/Equity/utils/streamingUpdate";
const initialState = {
    data: null,
    sectorPerformanceLoader: true,
    errorData: {
        error: null,
        isOpen: false,
    },
    updatedTime: "",
};
const sectorPerformance = (state = initialState, action) => {
    switch (action.type) {
        case SECTOR_PERFORMANCE:
            return Object.assign(Object.assign({}, state), { data: action.payload.data, updatedTime: action.payload.updatedTime });
        case SECTOR_PERFORMANCE_STREAM:
            return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { sectorPerformanceListPositive: marketStreamingUpdate(state.data.sectorPerformanceListPositive, action.payload.qouteStream), sectorPerformanceListNegative: marketStreamingUpdate(state.data.sectorPerformanceListNegative, action.payload.qouteStream) }), updatedTime: action.payload.qouteStream.updatedTime });
        case SECTOR_PERFORMANCE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case SECTOR_PERFORMANCE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case SECTOR_START_LOADER:
            return Object.assign(Object.assign({}, state), { sectorPerformanceLoader: true });
        case SECTOR_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { sectorPerformanceLoader: false });
        default:
            return Object.assign({}, state);
    }
};
export default sectorPerformance;
